/* Sticky "Masz jakies pytania?" - rozwijanie panelu z formularzem.
   Inicjalizacja takze na shopify:section:load, bo edytor motywu podmienia
   HTML sekcji bez odswiezenia strony. */
(function () {
  function init(root) {
    var widget = root.querySelector('[data-ask-sticky]');
    if (!widget || widget.dataset.ready === 'true') return;
    widget.dataset.ready = 'true';

    var toggle = widget.querySelector('[data-ask-toggle]');
    var panel = widget.querySelector('[data-ask-panel]');
    var close = widget.querySelector('[data-ask-close]');
    if (!toggle || !panel) return;

    function setOpen(open) {
      panel.hidden = !open;
      widget.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = panel.querySelector('input, textarea');
        if (first) first.focus();
      }
    }

    /* Znaczek hCaptcha, ktory Shopify dokleja do formularzy kontaktowych,
       stoi w tym samym rogu - styl sekcji stawia go NAD pigulka. Mierzymy sama
       pigulke, nie caly widzet: przy otwartym panelu pigulka jest schowana
       (0 px) i wtedy wartosc zostaje, zeby znaczek nie skakal. */
    function zmierz() {
      if (toggle.offsetHeight > 0) {
        document.documentElement.style.setProperty('--ask-sticky-wysokosc', toggle.offsetHeight + 'px');
      }
    }
    zmierz();
    if ('ResizeObserver' in window) new ResizeObserver(zmierz).observe(toggle);

    toggle.addEventListener('click', function () {
      setOpen(panel.hidden);
    });

    if (close) {
      close.addEventListener('click', function () {
        setOpen(false);
        toggle.focus();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (panel.hidden) return;
      if (widget.contains(event.target)) return;
      setOpen(false);
    });

    /* Po wyslaniu formularza Shopify wraca na te sama strone - panel ma
       zostac otwarty, zeby klient zobaczyl potwierdzenie albo blad. Ale
       Shopify oznacza jako wyslane WSZYSTKIE formularze kontaktowe na stronie,
       wiec otwieramy tylko wtedy, gdy kotwica adresu wskazuje ten formularz
       (inaczej panel wyskakiwal po pytaniu o produkt). */
    /* Przycisk zakupu na ekranie = pigulka schodzi z drogi, bo na komputerze
       stoi w tym samym rogu co cena na przycisku (audyt 26.10.2026). Tak samo
       przycisk zestawu probek i stopka (przelacznik kraju i waluty, linki) -
       audyt 27.10.2026. */
    var doUnikania = document.querySelectorAll('.product-cta, .sample-set__submit, .site-footer');
    if (doUnikania.length && 'IntersectionObserver' in window) {
      var widoczne = new Set();
      var obserwator = new IntersectionObserver(function (wpisy) {
        wpisy.forEach(function (wpis) {
          if (wpis.isIntersecting) widoczne.add(wpis.target);
          else widoczne.delete(wpis.target);
        });
        widget.setAttribute('data-unika', widoczne.size ? 'true' : 'false');
      });
      doUnikania.forEach(function (element) { obserwator.observe(element); });
    }

    var formularz = panel.querySelector('form');
    var kotwica = window.location.hash.slice(1);
    var moj = !kotwica || (formularz && formularz.id === kotwica);
    if (panel.querySelector('[data-ask-posted]') && moj) setOpen(true);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState !== 'loading') init(document);
})();
